module.exports = __webpack_public_path__ + "static/media/photos.6a76bb43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/manage-redesign/photos.svg
// module id = 1475
// module chunks = 49